import img from './../../assets/logo.svg';
import './style.css';

export const Header = ({setIsHome}) => {

    return (

        <header>
            <img src={img} alt="Logo" className="logo-header" />
            <button onClick={()=> {setIsHome(true)}}>ínicio</button>
        </header>

    );

}